// Decorative nature backdrops (oceans, waves, clouds, landscapes, waterfalls).
// A soft, overlaid banner behind page headers — stays legible, adds warmth.
const SCENES = [
  "https://images.unsplash.com/photo-1505118380757-91f5f5632de0?auto=format&fit=crop&w=1600&q=70", // aerial waves
  "https://images.unsplash.com/photo-1540979388789-6cee28a1cdc9?auto=format&fit=crop&w=1600&q=70", // misty mountains
  "https://images.unsplash.com/photo-1522645951282-750282e3b142?auto=format&fit=crop&w=1600&q=70", // waterfall
  "https://images.unsplash.com/photo-1536244636800-a3f74db0f3cf?auto=format&fit=crop&w=1600&q=70", // golden clouds
  "https://images.unsplash.com/photo-1513553404607-988bf2703777?auto=format&fit=crop&w=1600&q=70", // ocean waves + sand
  "https://images.pexels.com/photos/34742289/pexels-photo-34742289.jpeg?auto=compress&cs=tinysrgb&w=1600", // pink peak sunrise
];

function pick(seed) {
  if (!seed) return SCENES[Math.floor(Math.random() * SCENES.length)];
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) % 997;
  return SCENES[h % SCENES.length];
}

// eslint-disable-next-line
export default function PageHero({ eyebrow, title, subtitle, seed, actions, icon: Icon, image, height = "h-52 sm:h-60" }) {
  const bg = image || pick(seed);
  return (
    <div className={`relative overflow-hidden rounded-3xl ${height}`} data-testid="page-hero">
      <img src={bg} alt="" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-tr from-[#2C2724]/80 via-[#8a3d1f]/45 to-[#F27A54]/25" />
      <div className="absolute inset-0 flex flex-col justify-end p-5 sm:p-7">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div className="max-w-2xl text-white">
            {eyebrow && <p className="overline flex items-center gap-1.5 text-[11px] text-white/85">{Icon && <Icon size={14} weight="fill" />}{eyebrow}</p>}
            <h1 className="mt-1 font-display text-4xl font-black tracking-tight drop-shadow-sm sm:text-5xl">{title}</h1>
            {subtitle && <p className="mt-1.5 text-sm text-white/85 sm:text-base">{subtitle}</p>}
          </div>
          {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
        </div>
      </div>
    </div>
  );
}
